import { styled } from '@cp/ds/src/theme/styled';

export const StyledList = styled('ul')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
});
